export const assetFragment = `
  fragment Asset on AssetInterface {
    ... on Asset_Assets {
      id
      alt_de
      permalink
      extension
      is_image
      width
      height
      focus_css
    }
  }
`
